export default "/_next/static/media/SourceSansProItalic.211b474c4a355822fa89b3eacbda9b02.woff2";